export default "__VITE_ASSET__25bcc0f1__"